import { Navigate, useLocation } from "react-router-dom";

export default function PersonBenefitsPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/beneficiaries`} replace />;
}
